/**
 * Signup Form module.
 */
import iframe from '../components/iframe';

const signupForm = () => {
  const signupFormID = 'signup-form';
  const iframeResizerOptions = {
    checkOrigin: false,
  };

  const init = () => {
    const signupFormElement = document.getElementById(signupFormID);
    if (signupFormElement !== null) {
      iframe(signupFormElement, iframeResizerOptions);
    }
  };

  return {
    init,
  };
};

export default signupForm();
